<template>
  <!-- 钱包支付账户密码设置与邮箱验证弹窗容器 -->
  <van-popup
    v-model="show"
    :closeable="currentComponent !== 'SettingResult'"
    :close-on-click-overlay="currentComponent === 'SettingResult'"
    class="wallet-account-popup"
    :class="[displayClassName, isNewClass]"
    :style="{ height: popupHeight }"
    position="bottom"
    round
    :overlay-style="{ background: 'rgba(0,0,0, 0.8)' }"
  >
    <component
      :show="show"
      :is="currentComponent"
      :hasEmail="hasEmail"
      :pwOperation="pwOperation"
      @jumpto="onSwitchComponent"
      :configData="configData"
    ></component>
  </van-popup>
</template>

<script>
  import Vue from 'vue'
  import { Toast } from 'vant'
  import { mapState, mapMutations, mapGetters, mapActions } from 'vuex'
  import PasswordSetting from './subComponents/PasswordSetting'
  import EmailVerification from './subComponents/EmailVerification'
  import SettingResult from './subComponents/Result.vue'
  import { platformType } from '@/utils/platform'
  import { encodePasswordBySha256 } from '@/api/common'
  import { setPayPassword, updatePayPassword } from '@/api/coin'
  import {
    trackWalletPwBindResult,
    trackWalletPwChangeResult,
    trackPwSettingPopupShow,
  } from '@/pages/Wallet/firebase'

  Vue.use(Toast)

  export default {
    name: 'wallet-account-popup',
    components: {
      PasswordSetting,
      EmailVerification,
      SettingResult,
    },
    props: {
      showPopup: Boolean,
      pageName: String,
      pwOperation: String, // 两种值：initPW / resetPW
    },
    data() {
      return {
        show: this.showPopup,
        currentComponent: 'PasswordSetting',
        configData: {},
        platformType,
        emailParams: {}, // 保存来自子组件的传参： email、 code 、 codeId
        isFinished: false, // 记录是否完成密码设置与验证流程
      }
    },
    computed: {
      ...mapState([
        'region',
        'isDesktop',
        'isTurbo',
        'userInfo',
        'paymentPassword',
        'paymentAccountInfo',
      ]),
      ...mapGetters(['isNewClass']),
      displayClassName() {
        const classMap = {
          H5: 'display-mobile',
          GT: 'display-game-turbo',
          PC: 'display-desktop',
          APP: 'display-in-app',
        }
        return classMap[this.platformType()]
      },
      popupHeight() {
        return this.currentComponent === 'SettingResult'
          ? 'auto'
          : this.isDesktop
          ? '70%'
          : this.isTurbo
          ? '88%'
          : '80%'
      },
      hasEmail() {
        const { email } = this.userInfo || {}
        return !!email
      },
      walletBoundEmail() {
        const { email: userEmail } = this.userInfo || {}
        const { email } = this.paymentAccountInfo || {}
        // 未初始化支付账户默认绑定登录邮箱
        return (
          (this.pwOperation === 'initPW' && userEmail) ||
          (this.pwOperation === 'resetPW' && email)
        )
      },
      isFrozen() {
        const { status } = this.paymentAccountInfo || {}
        return status === 2
      },
    },
    watch: {
      showPopup(val) {
        this.show = val
        if (val) {
          this.handleTrackShowEvent(this.currentComponent)
          const { status } = this.paymentAccountInfo || {}
          if (!status) {
            // 只有在未获取到账户信息的时候请求接口
            this.getWalletBalance()
          }
        }
      },
      show(val) {
        this.$emit('switchPopup', val)
        if (!val) {
          this.$emit('onPopupClosed', { request: this.isFinished })
          setTimeout(() => {
            this.currentComponent = 'PasswordSetting' // 重置窗口
          }, 1200)
        }
      },
      currentComponent(val) {
        this.handleTrackShowEvent(val)
      },
    },
    destroyed() {
      this.setPaymentPassword('') // 关闭弹窗后务必清除密码
    },
    methods: {
      ...mapActions(['getWalletBalance']),
      ...mapMutations(['setPaymentPassword', 'setPaymentAccountInfo']),
      handleTrackShowEvent(val) {
        if (val === 'PasswordSetting' && this.show) {
          trackPwSettingPopupShow({
            page: this.pageName,
            pw_operation: this.pwOperation,
          })
        }
      },
      handleSettingResult(data) {
        this.currentComponent = 'SettingResult'
        this.configData = {
          ...data,
        }
        const { status, inFrozenState } = data
        const { frozenScene } = this.paymentAccountInfo || {}
        if (status === 1 && inFrozenState) {
          // 如果是账户冻结的情况下重置密码成功，则直接将钱包账户状态改为正常
          // 目的是避免在重新查询账户信息接口响应之前用户再次点击交易弹出冻结弹窗
          if (frozenScene === 1) {
            let temp = { ...this.paymentAccountInfo, status: 1 }
            delete temp.frozenScene
            this.setPaymentAccountInfo(temp)
          }
        }
      },
      onSwitchComponent(val) {
        if (typeof val === 'string' && val === 'password-setting') {
          this.currentComponent = 'PasswordSetting'
        } else if (typeof val === 'object' && val.type === 'email') {
          this.configData = {
            email: this.walletBoundEmail,
          }
          this.currentComponent = 'EmailVerification'
        } else if (typeof val === 'object' && val.type === 'request') {
          if (this.pwOperation === 'initPW' && this.hasEmail) {
            this.emailParams = { email: this.walletBoundEmail }
          } else {
            this.emailParams = val.data
          }
          this.handlePostRequset()
        } else if (typeof val === 'object' && val.type === 'close') {
          if (val.value === 1) {
            this.isFinished = true
          }
          // 只有在成功状态下自动关闭
          setTimeout(() => {
            this.show && (this.show = false)
          }, 3000)
        } else if (typeof val === 'object' && val === 'result') {
          this.handleSettingResult(val.data)
        }
      },
      handlePostRequset() {
        const {
          initPaymentPassword,
          resetPaymentPassword,
          userInfo,
          emailParams,
          paymentPassword,
        } = this
        if (this.pwOperation === 'initPW') {
          // 首次设置密码并绑定邮箱
          const params = {
            password: encodePasswordBySha256(paymentPassword),
            ...emailParams,
            userId: userInfo?.kicoinId || '',
          }
          this.postPaymentPassword(
            initPaymentPassword,
            trackWalletPwBindResult,
            params
          )
        } else if (this.pwOperation === 'resetPW') {
          // 忘记密码时重设密码
          const { code, codeId } = emailParams
          const params = {
            passwordNew: encodePasswordBySha256(paymentPassword),
            code,
            codeId,
            userId: userInfo?.kicoinId || '',
          }
          this.postPaymentPassword(
            resetPaymentPassword,
            trackWalletPwChangeResult,
            params
          )
        }
      },
      async initPaymentPassword(params) {
        // 用于初始化钱包支付密码
        try {
          const response = await setPayPassword(params)
          return Promise.resolve(response)
        } catch (e) {
          return Promise.reject(e)
        }
      },
      async resetPaymentPassword(params) {
        // 用于忘记密码时重设密码
        try {
          const response = await updatePayPassword(params)
          return Promise.resolve(response)
        } catch (e) {
          return Promise.reject(e)
        }
      },
      postPaymentPassword(requestFunc, trackFunc, params) {
        requestFunc(params)
          .then((response) => {
            let inFrozenState = false
            if (response && response.result) {
              const { isFrozen } = response
              inFrozenState = isFrozen || false
              // 密码设置成功埋点
              trackFunc({
                page: this.pageName,
                code: 1,
              })
              this.pwOperation === 'initPW' && this.$emit('firstCreatePassword')
              this.handleSettingResult({ status: 1, inFrozenState }) // 展示成功页
            } else if (response && !response.result) {
              // 密码设置失败埋点
              trackFunc({
                page: this.pageName,
                code: 0, // 数据库入库失败
              })
              this.handleSettingResult({ status: 0, errcode: 0, inFrozenState }) // 展示失败页
            }
          })
          .catch((e) => {
            const { code } = e
            // 密码设置异常埋点
            trackFunc({
              page: this.pageName,
              code,
            })
            switch (String(code)) {
              case '21008': // 验证码不匹配
                this.handleSettingResult({
                  status: 0,
                  errcode: code,
                  inFrozenState: this.isFrozen,
                }) // 展示失败页
                break
              case '20001': // T币账户不存在
              case '20002': // T币账户已冻结
              case '20004': // 存在多个T币账户
              case '20008': // T币账户已注销
              case '21000': // 支付密码已存在
              case '21003': // 新旧密码相同
              case '21007': // 验证码已使用过
              case '21009': // 验证码已过期
                this.handleSettingResult({ status: 0, errcode: code }) // 展示失败页
                break
              case '21005': // 验证码校验失败
              case '21006': // 验证码不存在
                Toast.fail(this.$t(`apiErrorTips.${code}`))
                break
              default:
                Toast.fail(this.$t(`apiErrorTips.default`))
            }
          })
      },
    },
  }
</script>
<style lang="scss" scoped src="./index.scss"></style>
<style lang="scss" scoped>
  @media screen and (min-device-width: 1080px) {
    @import './index_pc.scss';
  }
</style>
<style lang="scss" scoped>
  .wallet-account-popup {
    background: #f9f9f9;
    .popup-title {
      font-weight: 800;
      font-size: 51px;
      line-height: 70px;
      text-align: center;
      margin: 40px 0;
    }
  }
  .wallet-account-popup.display-desktop {
    width: 414px;
    left: 50%;
    margin-left: -208px;
    color: #000;
    .popup-title {
      font-weight: 800;
      font-size: 19.6px;
      line-height: 26.8px;
      text-align: center;
      margin: 15px 0;
    }
  }
  .wallet-account-popup.is-new {
    background: $gray-popup;
  }
</style>
